import React, { useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import brandIcon from "./assets/brand/Inverlux-Icon_512.png";
import styles from "./InverluxApps.module.css";

const pageMetadata = {
  "/": {
    title: "Inverlux Apps | Focused browser utilities",
    description:
      "Small, focused browser utilities developed by Inverlux LLC.",
  },
  "/gmail-collapse-all": {
    title: "Collapse All for Gmail | Inverlux Apps",
    description:
      "A free Chrome extension that keeps a convenient Collapse all control available in Gmail conversation view.",
  },
  "/gmail-collapse-all/privacy": {
    title: "Privacy Policy | Collapse All for Gmail",
    description:
      "Privacy policy for the Collapse All for Gmail Chrome extension from Inverlux LLC.",
  },
  "/support": {
    title: "Support | Inverlux Apps",
    description: "Support for browser utilities developed by Inverlux LLC.",
  },
};

const AppsLayout = () => {
  const location = useLocation();

  useEffect(() => {
    const metadata = pageMetadata[location.pathname] || pageMetadata["/"];
    const description = document.querySelector('meta[name="description"]');
    const previousTitle = document.title;
    const previousDescription = description
      ? description.getAttribute("content")
      : null;

    document.title = metadata.title;
    if (description) {
      description.setAttribute("content", metadata.description);
    }

    return () => {
      document.title = previousTitle;
      if (description && previousDescription !== null) {
        description.setAttribute("content", previousDescription);
      }
    };
  }, [location.pathname]);

  return (
    <div className={styles.site}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <Link className={styles.brand} to="/" aria-label="Inverlux Apps home">
            <img className={styles.brandMark} src={brandIcon} alt="" />
            <span>
              <span className={styles.brandName}>Inverlux Apps</span>
              <span className={styles.brandCompany}>by Inverlux LLC</span>
            </span>
          </Link>
          <nav className={styles.navigation} aria-label="Apps navigation">
            <Link to="/gmail-collapse-all">Collapse All</Link>
            <Link to="/gmail-collapse-all/privacy">Privacy</Link>
            <Link to="/support">Support</Link>
          </nav>
        </div>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>

      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <div className={styles.footerTopline}>
            <span>Inverlux Apps</span>
            <span>Browser utilities developed by Inverlux LLC</span>
          </div>
          <p className={styles.disclaimer}>
            Gmail is a trademark of Google LLC. Collapse All for Gmail is
            independently developed by Inverlux LLC and is not affiliated with
            or endorsed by Google.
          </p>
          <div className={styles.footerLinks}>
            <Link to="/gmail-collapse-all/privacy">Privacy Policy</Link>
            <Link to="/support">Support</Link>
            <a href="mailto:support@inverlux.com">support@inverlux.com</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AppsLayout;
